@if (isLoading) {
  <app-loader></app-loader>
}
<div class="quiz-question-div">
  <div class="question-div">
    <p class="question-title">
      <ng-container *ngFor="let part of statementParts">
        <span *ngIf="part.type === 'text'">{{ part.content }}</span>
        <img
          *ngIf="part.type === 'image'"
          [src]="part.content"
          class="question-image"
          alt="Question image"
        />
        <pre
          *ngIf="part.type === 'code'"
          class="code-block"
        ><code>{{ part.content }}</code></pre>
      </ng-container>
    </p>
    @if (selectedQuestion.QUESTION_TYPE == questionType.multi_correct) {
      <div class="marking-scheme-div"><i>{{questionPageUIStrings.multi_answer}}</i></div>
    }
    <div class="marking-scheme-div"><i>{{questionPageUIStrings.correct_mark}}</i></div>
    <span class="option-container">
      <input
        [type]="selectedQuestion.QUESTION_TYPE == questionType.multi_correct ? 'checkbox' : 'radio'"
        id="option1"
        name="option1"
        [checked]="selectedOption.includes('OPTION_1')"
        (click)="saveResponse('OPTION_1')"
      />
      <label for="option1">
        <ng-container *ngFor="let part of optionParts[0]">
          <span *ngIf="part.type === 'text'">{{ part.content }}</span>
          <img
            *ngIf="part.type === 'image'"
            [src]="part.content"
            class="question-image"
            alt="Option image"
          />
          <pre
            *ngIf="part.type === 'code'"
            class="code-block"
          ><code>{{ part.content }}</code></pre>
        </ng-container>
      </label>
    </span>
    <span>
      <input
        [type]="selectedQuestion.QUESTION_TYPE == questionType.multi_correct ? 'checkbox' : 'radio'"
        id="option2"
        name="option2"
        [checked]="selectedOption.includes('OPTION_2')"
        (click)="saveResponse('OPTION_2')"
      />
      <label for="option2">
        <ng-container *ngFor="let part of optionParts[1]">
          <span *ngIf="part.type === 'text'">{{ part.content }}</span>
          <img
            *ngIf="part.type === 'image'"
            [src]="part.content"
            class="question-image"
            alt="Option image"
          />
          <pre
            *ngIf="part.type === 'code'"
            class="code-block"
          ><code>{{ part.content }}</code></pre>
        </ng-container>
      </label>
    </span>
    <span>
      <input
        [type]="selectedQuestion.QUESTION_TYPE == questionType.multi_correct ? 'checkbox' : 'radio'"
        type="radio"
        id="option3"
        name="option3"
        [checked]="selectedOption.includes('OPTION_3')"
        (click)="saveResponse('OPTION_3')"
      />
      <label for="option3">
        <ng-container *ngFor="let part of optionParts[2]">
          <span *ngIf="part.type === 'text'">{{ part.content }}</span>
          <img
            *ngIf="part.type === 'image'"
            [src]="part.content"
            class="question-image"
            alt="Option image"
          />
          <pre
            *ngIf="part.type === 'code'"
            class="code-block"
          ><code>{{ part.content }}</code></pre>
        </ng-container>
      </label>
    </span>
    <span>
      <input
        [type]="selectedQuestion.QUESTION_TYPE == questionType.multi_correct ? 'checkbox' : 'radio'"
        id="option4"
        name="option4"
        [checked]="selectedOption.includes('OPTION_4')"
        (click)="saveResponse('OPTION_4')"
      />
      <label for="option4">
        <ng-container *ngFor="let part of optionParts[3]">
          <span *ngIf="part.type === 'text'">{{ part.content }}</span>
          <img
            *ngIf="part.type === 'image'"
            [src]="part.content"
            class="question-image"
            alt="Option image"
          />
          <pre
            *ngIf="part.type === 'code'"
            class="code-block"
          ><code>{{ part.content }}</code></pre>
        </ng-container>
      </label>
    </span>
  </div>
  <div class="action-buttons">
    <p-button
      severity="success"
      [label]="selectedQuestionRecord.isLast ? questionPageUIStrings.submit_test : questionPageUIStrings.next"
      [outlined]="true"
      [disabled]="selectedOption.length == 0"
      [style.cursor]="selectedOption.length == 0 ? 'not-allowed' : 'pointer'"
      (click)="saveAndNext()"
    ></p-button>
    <p-button
      severity="danger"
      [label]="clearButtonLabel"
      [disabled]="!selectedQuestionRecord.isAnswered"
      [outlined]="true"
      [style.cursor]="!selectedQuestionRecord.isAnswered ? 'not-allowed' : 'pointer'"
      (click)="clear()"
    ></p-button>
    <p-button
      severity="warning"
      [label]="reviewButtonLabel"
      [outlined]="true"
      (click)="review()"
    ></p-button>
  </div>
  <p class="disclaimer"><b>{{ questionPageUIStrings.disclaimer_label }}</b>{{ questionPageUIStrings.disclaimer_info }}</p>
</div>
